<ng-container *transloco="let t">
    @if (!started) {
        <camera-purpose-notice
            purpose="CODE"
            (start)="started = true"
        ></camera-purpose-notice>
    } @else {
        <html-qrcode-scanner
            #htmlQrcodeScanner
            [fps]="10"
            [aspectRatio]="1.333334"
            [qrbox]="qrbox"
            [disableFlip]="false"
            [supportCameraOrFile]="'camera'"
            (onSuccess)="handleScanSuccess($event)"
            (onError)="handleScanError($event)"
        ></html-qrcode-scanner>

        @if (htmlQrcodeScanner.isLoading) {
            <p>⌛ {{ t("LOADING") }}...</p>
        }
    }

    <div class="mt-2 flex items-center justify-center">
        <button
            class="w-fit bg-slate-200"
            mat-flat-button
            type="button"
            (click)="close()"
        >
            <mat-icon> stop_screen_share </mat-icon>
            {{ t("STOP-SCANNING") }}
        </button>
    </div>

</ng-container>
